import { useState } from 'react';
import styles from './Logo.module.scss';

export const Logo = ({
  src,
  name,
  className,
}: {
  src?: string | null;
  name: string;
  className?: string;
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError || !src) {
    return (
      <div className={`${styles['logo']} ${styles['logo-placeholder']} ${className}`}>
        {name.charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <div className={`${styles['logo']} ${className}`}>
      <img
        src={src}
        alt={`${name} logo`}
        className={styles.logo}
        onError={() => setHasError(true)}
      />
    </div>
  );
};
